import React from "react"

const StudySessions = () => {
  return <div>STUDY SESSIONS</div>
}

export default StudySessions;
